import { mutateByPath } from "../../../utility";
import { ARSTActionSetScaffoldColWidth, ArsTableState } from "../interface";
import {
  isArsTableColumnGroupLabel,
  isArsTableColumnOperationCell,
  isArsTableRowHeaderCell,
} from "../typeguards";
import { getColumnCells } from "./getColumnCells";

/**
 * Updates the width of a scaffold column in both the scaffold model and body data.
 *
 * @param state - Current ARS table state
 * @param action - Width update action for a scaffold column
 * @returns Updated ARS table state
 */
export const arst_setScaffoldColWidth = <T>(
  state: ArsTableState<T>,
  action: ARSTActionSetScaffoldColWidth,
): ArsTableState<T> => {
  const colCells = getColumnCells(state.calculatedTableRows, action.colId);
  const targetCell = colCells.find(
    (cell) =>
      isArsTableRowHeaderCell(cell, state.settings.editorProps.isT) ||
      isArsTableColumnOperationCell(cell, state.settings.editorProps.isT) ||
      (isArsTableColumnGroupLabel(cell, state.settings.editorProps.isT) &&
        (cell.colSpan ?? 1) === 1),
  );

  if (!targetCell || !state.scaffoldModel) return state;

  const targetDataPath = targetCell.dataPath.startsWith("/columns")
    ? `${targetCell.dataPath}/dimension`
    : `${targetCell.dataPath}/width`;
  const newBodyData = mutateByPath(state.bodyData, targetDataPath, action.width);
  const newScaffoldModel = mutateByPath(
    state.scaffoldModel,
    `/cols/${targetCell.columnIndex}/width`,
    action.width,
  );

  return {
    ...state,
    bodyData: newBodyData,
    scaffoldModel: newScaffoldModel,
    changed: true,
  };
};
